
<ng-content/>

@if (this.options ? (this.options.loading ?? false) : false) {
  <app-icon>autorenew</app-icon>
}
